import { render, staticRenderFns } from "./LoginPassword.vue?vue&type=template&id=65fad073&"
import script from "./LoginPassword.vue?vue&type=script&lang=js&"
export * from "./LoginPassword.vue?vue&type=script&lang=js&"
import style0 from "./LoginPassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports